import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { compose, ReduxWrapper } from 'common-data/datahelpers'
import clsx from 'clsx'
import styles from './DataCardMessage.less'

class DataCardMessagePlain extends React.Component {
  static DCType = 'Message'

  static propTypes = buildPropTypes([

  ], {
    children: pt.any
  })

  render () {
    const { children, className } = this.props

    const cls = clsx(styles.datacard, className)

    if (children) {
      return (
        <div className={cls}>
          {children}
        </div>
      )
    } else {
      return null
    }
  }
}

export const DataCardMessage = compose(
  ReduxWrapper([
  ],
  [])
)(DataCardMessagePlain)
